export default __webpack_public_path__ + "static/media/honey-green-tea.23d77ba4.png";